<section>
  <form class="row mb-2">
    <div class="col-12 col-md-4">
      <input type="search" placeholder="منبع" name="user" [(ngModel)]="criteria.Keyword" (input)="load()">
    </div>
    <div class="col-12 col-md-4">
      <select type="text" class="form-control" name="subtype" [(ngModel)]="criteria.Subtype" (change)="load()">
        <option value="">وضعیت</option>
        <option value="BLOCKED">مسدود</option>
        <option value="TRUSTED">تایید</option>
      </select>
    </div>
  </form>
  <table class="table">
    <thead>
      <tr>
        <th>مشخصه کاربری</th>
        <th>وضعیت</th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of list">
        <td>{{item.Identifier}}</td>
        <td>{{item.Subtype}}</td>
        <td class="btn-group">
          <i class="fa fa-edit fs-xl mx-2 pointer" (click)="data=item" title="ویرایش"></i>
          <i class="fa fa-trash f-red fs-xl mx-2 pointer" (click)="remove(item)" title="حذف"></i>
        </td>
        <td>
          <ng-container *ngIf="type=='Instagram'">
            <a [href]="'https://www.instagram.com/'+item.Identifier.replace('@','')+'/'" target="_blank">{{item.Identifier}}</a>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

  <section class="container border rounded-sm bg-white m-2 p-2">
    <div class="col-12" *ngIf="!data">
      <div class="col-10"></div>
      <div class="col-2">
        <button class="btn btn-green" type="button" (click)="add()">ایجاد</button>
      </div>
    </div>

    <form *ngIf="data" class="form-container form-horizontal">
      <div class="form-group">
        <div>مشخصه کاربری:</div>
        <input type="text" class="form-control" name="identifier" [(ngModel)]="data.Identifier" autofocus />
      </div>
      <div class="form-group">
        <div>وضعیت:</div>
        <select type="text" class="form-control" name="subtype" [(ngModel)]="data.Subtype">
          <option value="">وضعیت</option>
          <option value="BLOCKED">مسدود</option>
          <option value="TRUSTED">تایید</option>
        </select>
      </div>
      <ng-container *ngIf="type=='Telegram' || type=='Instagram'">
        <div class="form-group">
          <div>Regex:</div>
          <textarea dir="ltr" class="form-control" name="regex" [(ngModel)]="data.Data.Regex"></textarea>
        </div>
        <div class="form-group">
          <div>موقعیت:</div>
          <app-location name="location" [(ngModel)]="data.Data" placeholder="شهر یا استان این کانال"></app-location>
        </div>
      </ng-container>
      <div class="form-group">
        <button class="btn btn-green" type="button" (click)="save()">ذخیره</button>
      </div>
    </form>
  </section>
</section>